export enum TrainingPlanActions {
  Core = 'Core',
  Elective = 'Elective',
  Active = 'Active',
  Removed = 'Removed',
  Revoke = 'Revoke',
  Unlock = 'Unlock',
}

export enum TrainingStatus {
  Pending = 'Pending',
  Locked = 'Locked',
  Complete = 'Complete',
}